import { baseAPI } from "../../services/api";

export async function validatePhoneRequest(phone, channel = "QrCodeVirtual") {
  return baseAPI.post("/auth/v1/validatePhone", {
    MSISDN: phone,
    Model: "PC",
    Network: "Correios",
    OS: "Navegador",
    Source: channel,
    SystemVersion: "0.1",
    UniqueID: "xxxxx",
    Version: "0.1",
  });
}
